import React, { useEffect, useState } from "react";
import DateRange from "../DateRange/DateRange";
import { dashboardIcon } from "../../assets/img";
import { useNavigate } from "react-router-dom";

const StatCard = ({ title, value, showDollarIcon = false, navigateTo }) => {
  const navigate = useNavigate();

  const styles = {
    card: {
      backgroundColor: "#ffffff",
      borderRadius: "12px",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
      padding: "14px 16px",
      minHeight: "110px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      cursor: navigateTo ? "pointer" : "default",
    },

    header: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      marginBottom: "10px",
    },

    title: {
      fontSize: "15px",
      fontWeight: "400",
      color: "#9ca3af",
      margin: 0,
      display: "flex",
      alignItems: "center",
      gap: "6px",
    },

    iconContainer: {
      backgroundColor: "#a855f7",
      borderRadius: "50%",
      padding: "4px",
    },

    value: {
      fontSize: "22px",
      fontWeight: "700",
      color: "#000",
      margin: 0,
    },
  };

  return (
    <div style={styles.card} onClick={() => navigateTo && navigate(navigateTo)}>
      <div style={styles.header}>
        <h3 style={styles.title}>{title}</h3>

        <div style={styles.iconContainer}>
          <img
            src={dashboardIcon}
            style={{ height: "38px", width: "38px", borderRadius: "50%" }} // smaller image
            alt=""
          />
        </div>
      </div>

      <div style={styles.value}>{value}</div>
    </div>
  );
};

export default function PropertyDashboard({ isData, setFromDate, setToDate }) {
  const styles = {
    container: {
      //   minHeight: "100vh",
      padding: "32px",
      paddingLeft: "0px",
      borderTop: "2px solid #F2F2F2",
    },
    grid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
      gap: "24px",
      maxWidth: "1200px",
      margin: "0 auto",
    },
  };

  const stats = [
    {
      title: "Property Request",
      value: (isData?.property_request || 0).toFixed(2),
      showDollar: false,
      navigation: "/properties",
    },
    {
      title: "Property Onboard",
      value: (isData?.property_onboard || 0).toFixed(2),
      showDollar: false,
      navigation: "/overall-properties",
    },
    {
      title: "Booking Count",
      value: (isData?.booking_count || 0).toFixed(2),
      showDollar: false,
      navigation: "",
    },
    {
      title: "Total MMC",
      value: (isData?.total_mmc || 0).toFixed(2),
      showDollar: true,
      navigation: "/mmc-transaction-list",
    },
    {
      title: "Check In Count",
      value: (isData?.check_in_count || 0).toFixed(2),
      showDollar: false,
    },
    {
      title: "Check Out Count",
      value: (isData?.check_out_count || 0).toFixed(2),
      showDollar: false,
    },
    {
      title: "Hold Count",
      value: (isData?.hold_count || 0).toFixed(2),
      showDollar: false,
    },
    {
      title: "Cancelled Count",
      value: (isData?.cancelled_amount || 0).toFixed(2),
      showDollar: false,
    },
    {
      title: "MMC Pending",
      value: (isData?.mmc_pending || 0).toFixed(2),
      showDollar: true,
      navigation: "/properties-mmc",
    },
  ];

  return (
    <>
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div className="d-flex ac-jb mt-3 gap-1 flex-wrap">
          <DateRange setToDate={setToDate} setFromDate={setFromDate} />
        </div>

        <div style={styles.container}>
          <div style={styles.grid}>
            {stats.map((stat, index) => (
              <StatCard
                key={index}
                title={stat.title}
                value={stat.value}
                showDollarIcon={stat.showDollar}
                navigateTo={stat.navigation}
              />
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
